import React from "react";
import "./styles/DashboardNavBar.scss";
import "./styles/NavbarEvaluacionProgreso.scss"
const DashboardNavBarEvaluacionProgreso = (props) => {
  return (
    <div className=" navbarResponsiveEvaluacion">
      <div className=" containerResponsive">
        <div className="flex align-items-center justify-content-between w-full ">
          {
            props.titulo &&
            <div className="pl-2 text-lg font-bold text-lg-mobile">{props.titulo}</div>
          }
          {props.preguntas &&
            props.preguntas
          }
        </div>

      </div>
    </div>
  );
};

export default DashboardNavBarEvaluacionProgreso;
